export enum DiscoverCardType {
  Latest = 'today',
  Megatrends = 'megatrend',
  KnowHow = 'know-how',
  More = 'list',
}
